import * as React from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import "./header.scss";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  CheckIsAryehAnalyst,
  GetAccountList,
  changeDefaultAccount,
  getAffiliateList,
  getCaseTypes,
  getSalespersonList,
} from "./HeaderUtils";
import { Autocomplete, TextField, styled } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getAnalystList, getSellersList } from "./HeaderUtils";
import { SessionSorageInstance } from "../../Services/SessionStorageService";
import userRoles from "../../configs/userRolesConfigs";
import { pushAccounts } from "../../routes/appRoutes";
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import sizeConfigs from "../../configs/sizeConfigs";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import LanguageSelector from "../LanguageSelector/LanguageSelector";

const drawerWidth = sizeConfigs.sidebar.width;

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  paddingLeft: "60px",
  backgroundColor: "white",
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  "& .MuiAutocomplete-root": {
    width: "250px"
  },
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth - 65}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export default function Header({open}) {
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const accounts = useSelector((state: any) => state.account.account_list);
  let defaultAccount = useSelector(
    (state: any) => state.account.default_account
  );
  const navigate = useNavigate();

  useEffect(() => {
    const getAccounts = async () => {
      const accounts = await GetAccountList(dispatch);
      pushAccounts(accounts);
    };
    getAccounts();
    getCaseTypes(dispatch);
    if (SessionSorageInstance.getUserRole() === userRoles.admin) {
      getAnalystList(dispatch);
      getSellersList(dispatch);
      getSalespersonList(dispatch);
      getAffiliateList(dispatch);
    }
  }, []);

  const setValue = (value) => {
    changeDefaultAccount(dispatch, value);
    SessionSorageInstance.setDefaultAccount(value);
    CheckIsAryehAnalyst(dispatch);
  };

  const handleLogout = () => {
    SessionSorageInstance.clearSessionStorage();
    navigate('/');
  };

  return (
    <AppBar open={open} position="fixed">
      <Toolbar>
        {accounts && (
          <Autocomplete
            className="account"
            limitTags={-1}
            id="accounts"
            options={accounts}
            value={defaultAccount}
            getOptionLabel={(option) => option["label"] || ""}
            renderOption={(props, option) => (
              <li {...props} key={option.id}>
                {option.label}
              </li>
            )}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Account"
                placeholder="Account"
                required
              />
            )}
            onChange={(_, newValue) => {
              setValue(newValue);
            }}
          />
        )}
        <LanguageSelector />
        <Typography
          variant="h6"
          component="div"
          sx={{ flexGrow: 1 }}
        ></Typography>
        <LogoutOutlinedIcon sx={{ color: 'black', cursor: 'pointer' }} onClick={handleLogout} />

      </Toolbar>
    </AppBar>
  );
}



